import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';

export enum CreationType {
  AUTO_APPROVED_BY_AI = 'AUTO_APPROVED_BY_AI',
  SCANNED_BUT_EDITED_BY_USER = 'SCANNED_BUT_EDITED_BY_USER',
  MANUALLY_ENTERED = 'MANUALLY_ENTERED',
}

export enum CreationTypeDescription {
  AUTO_APPROVED_BY_AI = 'Document was scanned and claim auto approved by AI',
  SCANNED_BUT_EDITED_BY_USER = 'Document was scanned by AI but user changed the form',
  MANUALLY_ENTERED = 'Claim was entered manually',
}

interface Props {
  isEdited?: boolean,
  hasOcrDocument?: boolean,
  isAutoApprovedByAi?: boolean;
}

const useClaimCreationTypeLog = () => {
  const getClaimCreationType = useCallback((props: Props): CreationType | null => {
    if (!props?.hasOcrDocument) {
      return CreationType.MANUALLY_ENTERED;
    }

    if (props?.isEdited && props?.hasOcrDocument) {
      return CreationType.SCANNED_BUT_EDITED_BY_USER;
    }

    if (!props?.isEdited && props?.isAutoApprovedByAi) {
      return CreationType.AUTO_APPROVED_BY_AI;
    }

    return null;
  }, []);

  const sendClaimCreationDatadogLog = useCallback((props: Props) => {
    const creationType = getClaimCreationType(props);

    if (!creationType) {
      return;
    }

    datadogRum.addAction('Submitted New Claim', {
      claimCreationType: creationType,
      claimCreationTypeDescription: CreationTypeDescription?.[creationType],
    });
  }, [getClaimCreationType]);

  return {
    sendClaimCreationDatadogLog,
  };
};

export default useClaimCreationTypeLog;
